import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import {
  useMediaQuery,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
  colors,
} from '@material-ui/core';
import { Image } from 'components/atoms';
import { SectionHeader, IconAlternate } from 'components/molecules';
import { Box } from '@material-ui/core';
import { Button } from '@material-ui/core';

export const services = [
    {
      icon: 'fas fa-layer-group',
      title: 'Easy to use',
      subtitle:
        'Maximize time and resources with an intuitive experience Easy-to-use system and on-board informatics streamline workflow and analysis, making NGS accessible to novice and expert users',
    },
    {
      icon: 'fab fa-sketch',
      title: 'Cost-efficient',
      subtitle:
        'Achieve capacity for breakthroughs, support to sustain them Cost-efficient, high-throughput system delivers accurate results for emerging applications of increasing complexity',
    },
    {
      icon: 'fas fa-code',
      title: 'Application area',
      subtitle:
        "Small Whole-Genome Sequencing (microbe, virus)Exome & Large Panel Sequencing (enrichment-based)Single-Cell Profiling (scRNA-Seq, scDNA-Seq, oligo tagging assays)Transcriptome Sequencing (total RNA-Seq, mRNA-Seq, gene expression profiling)",
    },
  ];


const useStyles = makeStyles(theme => ({
  listItemAvatar: {
    marginRight: theme.spacing(2),
  },
  coverImage: {
    [theme.breakpoints.down('sm')]: {
      maxWidth: 500,
    },
  },
}));

const Mtwentytwo = props => {
  const { data, className, ...rest } = props;
  const classes = useStyles();

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <Box  className={className} {...rest} marginBottom={2} marginLeft= {2} marginRight={2} marginTop= {2} display="flex" justifyContent="space-evenly" alignItems="center" padding={2} border="1px solid #ccc" borderRadius="4px">
    <div className={className} {...rest}>
      <Grid container spacing={4} direction={isMd ? 'row' : 'column-reverse'}>
        <Grid item xs={12} md={6} data-aos="fade-up">
          <SectionHeader
            title={
              <span>
       Adaptive Focused Acoustics (AFA) Technology for DNA Shearing  
                <Typography component="span" variant="inherit" color="secondary">  M220</Typography>
                <br />
                <span></span>
              </span>
            }
            subtitle="Covaris provides tools and technologies to improve pre-analytical sample preparation. AFA enables a vast array of non-contact, isothermal processes to be developed for use in a broad range of applications in Genomics, Proteomics, Cell Biology and Drug Discovery, and Formulation."
            align="left"
            disableGutter
          />
          <SectionHeader
          subtitle =" 

          
          Covaris also develops devices and workflow systems to improve the discovery and measurement of molecules and biomarkers in tissue. 
          
          Covaris AFA® (Adaptive Focused Acoustics®) transmits acoustic energy at ultrasonic frequencies (>400KHz) and very short wavelengths (~3mm) and is uniquely able to focus the energy into your sample. AFA controls the shearing forces that fragment nucleic acids to the selected size. The process is isothermal, non contact, and quiet. 
          
          Covaris AFA technology in the M220 eliminates operator induced variations, improves recoveries, increases efficiency, and provides standardized results .
          
           
          
           "
           align="left"
           disableGutter
           />
          <List disablePadding>
            {data.map((item, index) => (
              <ListItem disableGutters key={index} data-aos="fade-up">
                <ListItemAvatar className={classes.listItemAvatar}>
                  <IconAlternate
                    size="small"
                    fontIconClass={item.icon}
                    color={colors.blue}
                  />
                </ListItemAvatar>
                <ListItemText primary={item.title} secondary={item.subtitle} />
              </ListItem>
            ))}
          </List>
          <SectionHeader
          ctaGroup={[
            <Button variant="contained" color="secondary" size="large">
              Quickbook
            </Button>,
            <Button variant="outlined" color="secondary" size="large">
              Contact
            </Button>,
          ]}
          align="left"
          disableGutter
          titleVariant="h3"
        />
        </Grid>
        <Grid
          item
          container
          justify="center"
          alignItems="center"
          xs={12}
          md={6}
          data-aos="fade-up"
        >
          <Image
            src="https://ik.imagekit.io/j6phbjneuop/me_9akERjFMr.png"
            alt="m220"
            className={classes.coverImage}
          />
        </Grid>
      </Grid>
    </div>
    </Box>
  );
};

Mtwentytwo.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
  /**
   * data to be rendered
   */
  data: PropTypes.array.isRequired,
};

export default Mtwentytwo;



